import { render, staticRenderFns } from "./ModifyRiskFactorPopup.vue?vue&type=template&id=4048cc4d&"
import script from "./ModifyRiskFactorPopup.vue?vue&type=script&lang=js&"
export * from "./ModifyRiskFactorPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports